import * as ReactRedux from 'react-redux';

import {SigninOverlayPassword} from "../SigninOverlayPassword.js";
import {actionTypesForSignin} from "../constants/signinOverlayConstants.js";


const mapStateToProps = (state) => {
	return {
		username: state.username
	}
};

const mapDispatchToProps = dispatch => {
	return {
		onReturnToEmailView: () => dispatch({
			type: actionTypesForSignin.RETURN_TO_EMAIL_VIEW
		}),
		showLoadingDots: () => dispatch({
			type: actionTypesForSignin.TOGGLE_LOADING
		})
	};
};

export const SigninOverlayPasswordContainer = ReactRedux.connect(
		mapStateToProps,
		mapDispatchToProps
)(SigninOverlayPassword);
